import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IrisSimpleLoaderComponent } from './iris-simple-loader/iris-simple-loader.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    IrisSimpleLoaderComponent,
  ],
  exports: [
    IrisSimpleLoaderComponent,
  ],
})
export class IrisSimpleLoaderModule { }
